module.exports = __webpack_public_path__ + "static/media/banner-extract-notas.6a31b686.png";